module.exports = __webpack_public_path__ + "img/re.ba6ff1f7.svg";